import { atom } from "jotai";

export const defaultProject = {
  project: {},
  projectStatus: {},
  currencyList: [],
  defaultComponentData:{},
  updateComponents:[],
  showAsset: false,
  showUseCase: false,
  showSystems: false,
  showBOM: false,
  showDeploy: false,
  timeSettingsValidated: false,
  assetCbCount:0,
  isSiteCreated:false,
  isDarkMode:false,
  flexName: "",
  enableHelpMenu:false,
  pathName:"",
  isEnergyReserveSelectd:false,
  tooltipData:{},
  resources:{},
};

export const projectAtomList = atom(defaultProject);
